import {Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {NgClass} from "@angular/common";
import {MatBadgeModule} from "@angular/material/badge";
import {MatRippleModule} from "@angular/material/core";
import {SpinnerComponent} from "src/app/modules/design-system/spinner/spinner.component";

@Component({
  selector: 'app-text-button',
  standalone: true,
  imports: [NgClass, MatBadgeModule, MatRippleModule, SpinnerComponent],
  templateUrl: './text-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-button.component.scss']
})
export class TextButtonComponent {
  @Input() color: 'primary'|'accent'|'accent-light'|'accent-secondary'| 'accent-secondary-inverted' | 'warn'|'success'|'warning'|'danger'|'danger-inverted'|'grey' = 'accent';
  @Input() type: 'default'|'stroked'|'flat'|'dashed' = 'default';
  @Input() shape: 'default'|'square'|'round' = 'default';
  @Input() size: 'default'|'compact' = 'default';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() panelClass = '';
  @Input() badge: string|number|undefined = undefined;
  @Input() badgePosition: 'above'|'above after'|'above before'|'after'|'before'|'below'|'below after'|'below before' = 'above after';
}
